// src/api/authService.js
import apiClient from "./apiClient";

export const getAppInfo = async (guestToken) => {
    const res = await apiClient.get(`/auth/version`);
    return res;
};

export const login = async (email, password) => {
    const res = await apiClient.post("/auth/login", { email, password });
    localStorage.setItem("accessToken", res.token);
    localStorage.setItem("refreshToken", res.refreshToken);
    if (res.role === 'user')
    {
        localStorage.setItem("activeOfficeName", res.active_office_name);
    }
    return res;
};

export const resendPassword = async (email) => {
    const res = await apiClient.post("/auth/resend-password", { email });
    return res;
};

export const loginGuest = async (guestToken) => {
    // guestToken is the URL param ?token=...
    const res = await apiClient.post(`/auth/guest-login?token=${guestToken}`);
    
    // store only access token (valid 60m) and office context
    localStorage.setItem("accessToken", res.token);
    localStorage.setItem("activeOfficeId", res.active_office_id);
    localStorage.setItem("activeOfficeName", res.active_office_name);

    return res;
};

export const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("activeOfficeName");
    localStorage.removeItem("activeOfficeId");
};

export const switchOffice = async (data) => {
  const res = await apiClient.post("/auth/switch-office", data);
  localStorage.setItem("accessToken", res.token);
  localStorage.setItem("refreshToken", res.refreshToken);
  if (res.role === 'user')
  {
      localStorage.setItem("activeOfficeName", res.active_office_name);
  }
  return res;
};

export const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) return null;

    try {
        const res = await apiClient.post("/auth/refresh", { refreshToken });
        localStorage.setItem("accessToken", res.token);
        return res.token;
    } catch (err) {
        return null;
    }
};

export const generateGuestToken = async () => {
    const res = await apiClient.post(`/guest-tokens`);
    return res;
};